export default __webpack_public_path__ + "static/media/info.931f0f2e.svg";